import { Injectable } from '@angular/core';
import { createEffect, Actions } from '@ngrx/effects';
import { CentralPartialState, CENTRAL_FEATURE_KEY } from './central.reducer';

import { ApiService, hasUnsavedChanges, MessageService, DataPersistence } from '@pos-app/core-ui';
import { map, mergeMap } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import {
  CentralActionTypes,
  FetchMyHelpComponents,
  FetchMyHelpComponentsFailed,
  FetchMyHelpComponentsSuccess,
  FetchSalesPeopleListSuccess,
  FetchSiteListSuccess,
  FetchTaskSummarySuccess,
  LoadCentralTasksSuccess,
  LoadOpenJobRequestTotalsSuccess,
  LoadTaskDetails,
  LoadTaskDetailsFailed,
  LoadTaskDetailsSuccess,
  LoadTasks,
  LoadTasksFailed,
  LoadTasksSuccess,
} from './central.actions';

@Injectable()
export class CentralEffects {
  //Effect to fetch my help components
  loadMyHelpComponents$ = createEffect(() => this.dataPersistence.fetch(CentralActionTypes.FETCH_MY_HELP_COMPONENTS, {
    run: (action: any, state: CentralPartialState) => {
      if (state[CENTRAL_FEATURE_KEY]?.myHelpComponents) {
        return new FetchMyHelpComponentsSuccess(state[CENTRAL_FEATURE_KEY]?.myHelpComponents);
      } else {
        return this.apiService.fetchMyHelpComponents().pipe(
          map((result) => {
            if (result?.helpComponent) {
              return new FetchMyHelpComponentsSuccess(result?.helpComponent);
            }
          })
        );
      }
    },
    onError: (action: any, error) => {
      return new FetchMyHelpComponentsFailed(error);
    },
  }));
  // Effect to load tasks
  loadTasks$ = createEffect(() => this.dataPersistence.fetch(CentralActionTypes.LOAD_TASKS, {
    run: (action: LoadTasks, state: CentralPartialState) => {
      return this.apiService.listTasks(action.payload).pipe(map((result) => new LoadTasksSuccess(result)));
    },
    onError: (action: LoadTasks, error) => {
      return new LoadTasksFailed(error);
    },
  }));
  // Effect to load task details
  loadTaskDetails$ = createEffect(() => this.dataPersistence.fetch(CentralActionTypes.LOAD_TASK_DETAILS, {
    run: (action: LoadTaskDetails, state: CentralPartialState) => {
      return this.apiService.fetchTaskDetail({ UKID: action.payload }).pipe(map((result) => new LoadTaskDetailsSuccess(result.ticket)));
    },
    onError: (action: LoadTaskDetails, error) => {
      return new LoadTaskDetailsFailed(error);
    },
  }));
  // Effect to fetch site list
  fetchSiteList$ = createEffect(() => this.dataPersistence.fetch(CentralActionTypes.FETCH_SITE_LIST, {
    run: (action: any, state: CentralPartialState) => {
      // Return cached site list if available
      if (state[CENTRAL_FEATURE_KEY].cachedSiteList?.siteList?.length > 0) {
        return;
      }
      return this.apiService.fetchSiteList().pipe(map((result) => new FetchSiteListSuccess(result)));
    },
  }));
  // Effect to fetch salespeople list
  fetchSalesPersonList$ = createEffect(() => this.dataPersistence.fetch(CentralActionTypes.FETCH_SALESPEOPLE_LIST, {
    run: (action: any, state: CentralPartialState) => {
      // Return cached salespeople list if available
      if (state[CENTRAL_FEATURE_KEY].cachedSalesPeopleList.length > 0) {
        return;
      }
      return this.apiService.fetchSalesPeople().pipe(map((result) => new FetchSalesPeopleListSuccess(result)));
    },
  }));
  // Effect to fetch task summary
  fetchTaskSummary$ = createEffect(() => this.dataPersistence.fetch(CentralActionTypes.FETCH_TASK_SUMMARY, {
    run: (action: any, state: CentralPartialState) => {
      return this.apiService.fetchTaskSummary(action.payload).pipe(map((result) => new FetchTaskSummarySuccess(result)));
    },
  }));
  loadTaskList$ = createEffect(() => this.dataPersistence.fetch(CentralActionTypes.LOAD_TASK_LIST, {
    run: (action: any, state: CentralPartialState) => {
      return this.apiService.listTasks(action.payload).pipe(map((result) => new FetchTaskSummarySuccess(result)));
    },
  }));
  loadCentralTasks$ = createEffect(() => this.dataPersistence.fetch(CentralActionTypes.LOAD_CENTRAL_TASKS, {
    run: (action: any, state: CentralPartialState) => {
      return this.apiService.fetchTaskTotals().pipe(map((result) => new LoadCentralTasksSuccess(result)));
    },
  }));
   loadJobRequestTotals$ = createEffect(() => this.dataPersistence.fetch(CentralActionTypes.LOAD_OPEN_JOB_REQUEST_TOTALS, {
    run: (action: any, state: CentralPartialState) => {
      return this.apiService.fetchOpenJobRequestTotals().pipe(map((result) => new LoadOpenJobRequestTotalsSuccess(result)));
    },
  }));
  constructor(private actions$: Actions, private apiService: ApiService, private dataPersistence: DataPersistence<CentralPartialState>) {}
}

